import { TRACK_FIELD_INPUT_PAYLOAD } from '@/lib';
import type { GenericObjectType } from '@/types';

export const ADDRESS_AUTO_COMPLETE_SUGGEST = ({
  addressType,
  charCount,
  country,
  errors,
  geoCountry,
  type,
}: {
  addressType: string;
  charCount: number;
  country: string;
  errors: [{ message: string }];
  geoCountry: string;
  type: string;
}): {
  addr_type: string;
  buyer_cntry: string;
  char_cnt: number;
  ipcountry: string;
  state_name: string;
  transition_name: string;
  int_err_desc?: string;
} => ({
  addr_type: addressType,
  buyer_cntry: country,
  char_cnt: charCount,
  ipcountry: geoCountry,
  state_name: 'address_suggest',
  transition_name: `${type}_address_suggest`,
  ...(errors?.length && { int_err_desc: errors[0].message }),
});

export const ADDRESS_AUTO_COMPLETE_SELECT = ({
  address,
  addressIndex,
  addressType,
  errors,
  type,
}: {
  address: GenericObjectType;
  addressIndex: number;
  addressType: string;
  errors: [{ message: string }];
  type: string;
}): {
  addr_indx: number;
  addr_type: string;
  state_name: string;
  transition_name: string;
  int_err_desc?: string;
  missing_fields?: string;
} => {
  const errorDetails: any = {};

  if (errors?.length) {
    errorDetails.int_err_desc = errors[0].message;
  } else if (address) {
    // Update missing fields in fpti log
    errorDetails.missing_fields = Object.keys(address)
      .filter(key => !address[key])
      .join(',');
  }

  return {
    addr_indx: addressIndex + 1, // array index + 1
    addr_type: addressType,
    state_name: 'address_select',
    transition_name: `${type}_address_select`,
    ...errorDetails,
  };
};

export const TRACK_ADDRESS_INPUT_PAYLOAD = ({
  addressType,
  charCount,
  fieldName,
  fieldType,
}: {
  addressType: string;
  charCount: number;
  fieldName: string;
  fieldType: string;
}): {
  addr_type: string;
  char_cnt: number;
  field_name: string;
  field_type: string;
  state_name: string;
  transition_name: string;
} => ({
  addr_type: addressType,
  ...TRACK_FIELD_INPUT_PAYLOAD({
    charCount,
    fieldName,
    fieldType,
  }),
});
